// Service để gọi API tỉnh/thành phố và phường/xã
const API_BASE_URL = 'https://provinces.open-api.vn/api/v2';

// Lấy danh sách tỉnh/thành phố
export const getProvinces = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/p/`);
    if (!response.ok) {
      throw new Error('Failed to fetch provinces');
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching provinces:', error);
    throw error;
  }
};

// Lấy danh sách phường/xã theo mã tỉnh
export const getWardsByProvince = async (provinceCode) => {
  try {
    const response = await fetch(`${API_BASE_URL}/w?province=${provinceCode}`);
    if (!response.ok) {
      throw new Error('Failed to fetch wards');
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching wards:', error);
    throw error;
  }
};
